import { gql } from '@apollo/client';

export const GET_DESK_CD_OFFERINGS = gql`
  query DeskCdOfferings {
    deskCdOfferings {
      publishUser
      cusip
      issuer
      coupon
      spread
      maturity
      callDate
      pays
      certNumber
      settle
      restrictions
      instType
      dateCreated
      instType
      status
      fedId
      seller
      disclosure
      financial
    }
  }
`;
